<template>
  <Dialog v-model="visible" :width="600" scrollable persistent :min_height="240">
    <template slot="title">
      <span class="title">{{ macroName }}</span>
    </template>
    <v-form ref="form" v-model="validEditor" lazy-validation>

      <TriggerEndpointSelector v-model="selectEndpointsT" :config="config" clearable multiple :label="$t('selector.triggers')" />
      <v-list-item class="px-0" v-for="(e, i) in selectEndpointsT" :key="i + '-t'">
        <v-list-item-avatar tile>
          <span class="font-weight-bold" v-if="e=='onboard-air-sensor-co2'">CO<sub>2</sub></span>
          <span class="font-weight-bold" v-else-if="e=='onboard-air-sensor-co'">CO</span>
          <span class="font-weight-bold" v-else-if="e=='onboard-air-sensor-voc'">VOC</span>
          <v-icon class="primary--text" v-else>{{ idToIcon[e] }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ config[e] ? config[e].name : $t(`type.${idToType[e]}`) }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action  class="ml-2" :style="[{'width': '280px'}]">
          <TriggerEndpointValueSelector v-model="valuesT[e]" :eType="idToType[e]" :eId="e" />
        </v-list-item-action>
      </v-list-item>
      <br>
      <EndpointSelector v-model="selectEndpoints" :availableEndpoints="availableEndpoints" :config="config" clearable multiple :label="$t('selector.actions')" />
      <v-list-item class="px-0" v-for="(e, i) in selectEndpoints" :key="i">
        <v-list-item-avatar tile>
          <img class="imgSize" src="@/assets/icon/curtain/curtain_up_50.svg" v-if="e=='smart-button-curtain-1'" />
          <v-icon class="primary--text" v-else>{{ idToIcon[e] }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ config[e] ? config[e].name : $t(`type.${idToType[e]}`) }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action  class="ml-2" :style="[idToType[e]=='FAN' ? {'width': '420px'} : {'width': '280px'}]">
          <EndpointValueSelector v-model="values[e]" :eType="idToType[e]" />
        </v-list-item-action>
      </v-list-item>
    </v-form>

    <template slot="actions">
      <v-btn v-if="item" :color="macroEnable ? 'error' : 'success'" :disabled="disableBtn" :loading="submittingE" text @click="toggleMacro()">{{ macroEnable ? $t('macro.disable'): $t('macro.enable') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="doSave()" :disabled="disableBtn" :loading="submitting">{{$t('save')}}</v-btn>
    </template>
  </Dialog>
</template>
<script>
import User from '@/components/auth/User'
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import EndpointSelector from '@/components/utils/select/EndpointSelector'
import EndpointValueSelector from '@/components/utils/select/EndpointValueSelector'
import TriggerEndpointSelector from '@/components/utils/select/TriggerEndpointSelector'
import TriggerEndpointValueSelector from '@/components/utils/select/TriggerEndpointValueSelector'

export default {
  name: 'MacroDialog',
  mixins: [BaseDialog, User],
  components: {
    Dialog,
    EndpointSelector,
    EndpointValueSelector,
    TriggerEndpointSelector,
    TriggerEndpointValueSelector
  },
  props: {
    pie: {
      type: String,
      required: true
    },
    item: {
      type: Object
    },
    macroIndex: {
      type: Number
    },
    macros: {
      Object
    }
  },
  data() {
    return {
      values: {},
      valuesT: {},
      validEditor: false,
      submitting: false,
      submittingE: false,
      selectEndpoints: [],
      selectEndpointsT: [],
      idToType: {
        "onboard-main-light": "LIGHT", 
        "external-light-1": "LIGHT", 
        "onboard-main-fan": "FAN", 
        "smart-button-curtain-1": "CURTAIN", 
        "onboard-sensor-temperature": "TEMPERATURE", 
        "onboard-sensor-humidity": "HUMIDITY", 
        "onboard-sensor-illumination": "ILLUMINATION", 
        "onboard-air-sensor-co2": "CONCENTRATION", 
        "onboard-air-sensor-co": "CONCENTRATION", 
        "onboard-air-sensor-voc": "CONCENTRATION", 
        "onboard-sensor-motion": "MOTION", 
        "onboard-sensor-smoke": "SMOKE", 
        "smart-button-3": "BUTTON", 
        "smart-relay-4": "SWITCH"
      },
      idToIcon: {
        "onboard-main-light": 'mdi-lightbulb', 
        "external-light-1": 'mdi-lightbulb', 
        "onboard-main-fan": 'mdi-fan', 
        "smart-button-curtain-1": "mdi-window-shutter-open", 
        "onboard-sensor-temperature": "mdi-thermometer", 
        "onboard-sensor-humidity": "mdi-water", 
        "onboard-sensor-illumination": "mdi-brightness-6", 
        "onboard-sensor-motion": "mdi-motion-sensor", 
        "onboard-sensor-smoke": "mdi-smoke-detector", 
        "smart-button-3": "mdi-gesture-tap", 
        "smart-relay-4": "mdi-toggle-switch"
      }
    }
  },
  computed: {
    info() {
      return (this.userDevice[this.pie] || {}).info || {};
    },
    config() {
      return (this.userDevice[this.pie] || {}).config || {};
    },
    availableEndpoints() {
      return this.info.map(i => i.id);
    },
    macroName() {
      return  this.item ? ((this.config || {})[this.item.name] || {}).name || this.item.name : this.$t('macro.add_macro');
    },
    isEditStatus() {
      return this.macroIndex !== null;
    },
    macroEnable() {
      return (this.item || {}).enable;
    },
    disableBtn() {
      return this.submitting || this.submittingE;
    }
  },
  methods: {
    async doSave() {
      this.submitting = true;
      let triggers = this.selectEndpointsT.map(e => {
        return {id: e, ...this.valuesT[e]}
      });
      let actions = this.selectEndpoints.map(e => {
        return {id: e, ...this.values[e]}
      });
      if (this.isEditStatus) {
        //Edit macro
        this.macros[this.macroIndex] = {
          name: this.item.name,
          enable: this.item.enable,
          actions: actions,
          triggers: triggers
        };
      } else {
        //Add macro
        let ml = this.macros.length;
        let list10 = [...Array(10).keys()].map(x => x + 1);
        let mnl = this.macros.map(m => parseInt(m.name.split('-')[1]));
        let diff = list10.filter(x => !mnl.includes(x));
        this.macros[ml] = {
          name: 'macro-' + JSON.stringify(Math.min(...diff)),
          enable: 0,
          actions: actions,
          triggers: triggers
        };
      }
      let cmd = {
        version: 1,
        agent: {
          id: this.userId
        },
        device: {
          id: this.pie
        },
        timestamp: new Date().getTime(),
        payload: {
          macroList: this.macros
        }
      };
      if (actions.length !=0 && triggers.length !=0) {
        await this.doCommand(cmd, 'macro/set');
        this.$emit('toast', this.$t('macro.save_successfully'));
        this.submitting = false;
        this.visible = false;
      } else {
        this.$emit('toast', this.$t('scene.no_selected_endpoint'));
        this.submitting = false;
      }
    },
    async toggleMacro() {
      this.submittingE = true;
      let triggers = this.selectEndpointsT.map(e => {
        return {id: e, ...this.valuesT[e]}
      });
      let actions = this.selectEndpoints.map(e => {
        return {id: e, ...this.values[e]}
      });
      let status = this.macroEnable ? 0 : 1;
      this.macros[this.macroIndex] = {
        name: this.item.name,
        enable: status,
        actions: actions,
        triggers: triggers
      };
      let cmd = {
        version: 1,
        agent: {
          id: this.userId
        },
        device: {
          id: this.pie
        },
        timestamp: new Date().getTime(),
        payload: {
          macroList: this.macros
        }
      };
      await this.doCommand(cmd, 'macro/set');
      this.$emit('toast', this.$t('macro.save_successfully'));
      this.submittingE = false;
      this.visible = false;
    }
  },
  mounted() {
    //triggers
    if (this.item && this.item.triggers) {
      this.item.triggers.forEach(i => {
        this.selectEndpointsT.push(i.id);
        let tempObj = {};
        tempObj.op = i.op;
        tempObj.value = i.value;
        tempObj.eventType = i.eventType;
        this.valuesT[i.id] = tempObj;
      })
    }
    //actions
    if (this.item && this.item.actions) {
      this.item.actions.map(a => {
        let tempObj = Object.entries(a).filter(e => e[1] !== -1);
        return Object.fromEntries(tempObj);
      }).forEach(i => {
        this.selectEndpoints.push(i.id);
        let tempObj = {};
        if (i.on) tempObj.on = i.on;
        if (i.brightness) tempObj.brightness = i.brightness;
        if (i.openDirection) tempObj.openDirection = i.openDirection;
        if (i.openPercent) tempObj.openPercent = i.openPercent;
        if (i.fanDirection) tempObj.fanDirection = i.fanDirection;
        if (i.fanSpeed) tempObj.fanSpeed = i.fanSpeed;
        this.values[i.id] = tempObj;
      })
    }
  }
}
</script>
<style scoped>
.imgSize {
  width: 20px;
  height: 20px;
}
</style>